/* eslint-disable no-underscore-dangle */
import { Howl, Howler } from 'howler';

const LISTEN_INTERVAL = 10;

class ReaderKaraoke {
  constructor(url, fragments, reader) {
    Howler.usingWebAudio = true;

    this.reader = reader;
    this.fragments = fragments || {};
    this.currentFragment = null;
    this.activeElementId = null;
    this.timerId = null;

    this.onPlay = this.onPlay.bind(this);
    this.onEnd = this.onEnd.bind(this);

    this.audio = new Howl({
      src: [url],
      onplay: this.onPlay,
      onend: this.onEnd,
    });
  }

  onPlay() {
    if (!this.timerId) {
      this.timerId = setInterval(() => {
        if (!this.audio) {
          clearInterval(this.timerId);
          return;
        }

        const {
          activeElementId,
          prevElementId,
        } = this.setActiveElement();

        if (this.audio.playing() && activeElementId && prevElementId !== activeElementId) {
          if (this.onFragmentChange) {
            this.onFragmentChange(activeElementId);
          }

          this.handleFragmentChange(activeElementId);
        }
      }, LISTEN_INTERVAL);
    }
  }

  onEnd() {
    if (this.onFragmentEnd) {
      this.onFragmentEnd();
    }

    this.cleanup();
  }

  setActiveElement() {
    const currentTime = this.audio.seek();
    const prevElementId = this.activeElementId;
    const { audioFragmentIds } = this.currentFragment || {};

    const elementId = (audioFragmentIds || []).find((id) => {
      const { clipBegin, clipEnd } = this.fragments[id] || {};

      return currentTime >= clipBegin && currentTime <= clipEnd;
    });

    this.activeElementId = elementId;

    return {
      activeElementId: elementId,
      prevElementId,
    };
  }

  handleFragmentChange(elementId) {
    const element = this.reader.findElement(`#${elementId}`);

    if (!element) {
      return;
    }

    if (!this.reader.isElementVisible(element)) {
      this.reader.openNextPage();
    }
  }

  cleanup() {
    clearInterval(this.timerId);

    this.timerId = null;
    this.activeElementId = null;
    this.currentFragment = null;
  }

  play(fragmentsDescriptor, onFragmentEnd, onFragmentChange) {
    const { startFragmentId, endFragmentId, audioFragmentIds } = fragmentsDescriptor || {};
    const startElement = this.fragments[startFragmentId];
    const endElement = this.fragments[endFragmentId];

    if (!startElement || !endElement) {
      return;
    }

    this.onFragmentChange = onFragmentChange;
    this.onFragmentEnd = onFragmentEnd;

    this.currentFragment = {
      startFragmentId,
      endFragmentId,
      clipBegin: startElement.clipBegin,
      clipEnd: endElement.clipEnd,
      audioFragmentIds,
    };

    // offset, duration - in milliseconds
    const offset = this.currentFragment.clipBegin * 1000;
    const duration = (this.currentFragment.clipEnd - this.currentFragment.clipBegin) * 1000;
    this.audio._sprite.currentSprite = [offset, duration];
    this.audio.play('currentSprite');
  }

  stop() {
    this.audio?.stop();

    if (this.onFragmentEnd) {
      this.onFragmentEnd();
    }

    this.cleanup();
  }

  destroy() {
    this.audio?.stop();
    this.cleanup();

    this.audio = null;
    Howler.usingWebAudio = false;
  }
}

export default ReaderKaraoke;
